'use client';
let _sPassive;
const supportsPassive = (node)=>{
    if (_sPassive === undefined) {
        try {
            const opts = Object.defineProperty({}, 'passive', {
                get: ()=>{
                    _sPassive = true;
                }
            });
            node.addEventListener('optsTest', ()=>{
                return;
            }, opts);
        } catch (_error) {
            _sPassive = false;
        }
    }
    return !!_sPassive;
};
const addEventListener = (element, eventName, callbackFn, opts)=>{
    // use event listener options when supported
    // otherwise it's just a boolean for the "capture" arg
    const listenerOpts = supportsPassive(element) ? {
        capture: !!opts.capture,
        passive: !!opts.passive
    } : !!opts.capture;
    let add;
    let remove;
    if (element.__zone_symbol__addEventListener) {
        add = '__zone_symbol__addEventListener';
        remove = '__zone_symbol__removeEventListener';
    } else {
        add = 'addEventListener';
        remove = 'removeEventListener';
    }
    element[add](eventName, callbackFn, listenerOpts);
    return ()=>{
        element[remove](eventName, callbackFn, listenerOpts);
    };
};

export { addEventListener };
//# sourceMappingURL=addEventListener.js.map
